export default __webpack_public_path__ + "static/media/226.3eca2952.jpg";